<template>
  <ExamAnalysis :path="'/entrain'" style="margin-top: 121px;"></ExamAnalysis>
</template>

<script>
  import ExamAnalysis from '@/page/modules/exam/analysis'
  export default {
    components: { ExamAnalysis },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/entrain/exam/analysis.vue